/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const chat_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m6.751 12.75-3 3v-5.024A5.239 5.239 0 0 1 6.001.75h3a5.252 5.252 0 0 1 5.033 3.75m9.217 9a5.25 5.25 0 0 0-5.25-5.25h-3a5.25 5.25 0 1 0 0 10.5h.75l4.5 4.5v-5.024a5.237 5.237 0 0 0 3-4.726Z"
    />
  </svg>
)
export default chat_medium
